<template>
    <tr class="dish-base-table__row dish-base-table__row_head">
        <th class="dish-base-table__cell dish-base-table__cell_head dish-base-table__cell_sortable" scope="col"
            v-for="column in columns"
            :key="column.id"
            @click="setDishSorting(column.id)"
        >
            <div class="dish-base-table__cell-content dish-base-table__cell-content_columns"
                :class="`dish-base-table__cell-content_${column.alignment}`"
            >
                <span class="dish-base-table__value">{{column.title}}</span>
                <svg-icon v-if="field === column.id" class="dish-base-table__value dish-base-table__value_icon"
                    :icon="direction === 'ASC' ? 'chevron-up' : 'chevron-down'"
                />
            </div>
        </th>
    </tr>
</template>

<script>
    import { mapMutations, mapState } from "vuex";

    export default {
        name: "DishBaseTableHeadRow",
        components: {
        },
        props: {
            columns: {
                type: Array,
                required: true
            }
        },
        computed: {
            ...mapState({
                field: state => state.dish.sorting.field,
                direction: state => state.dish.sorting.direction,
            }),
        },
        methods: {
            ...mapMutations([
                "setDishSorting",
            ]),
        }
    };
</script>
